import { CreateOrUpdateBaseService } from "../../../../common/services/createOrUpdateBase.service";
import { services } from "../../../../constants/services";


export class CreateOrUpdateUploadReactionsService extends CreateOrUpdateBaseService<any, any> {
  // url = `${services.userCampus}/createOrUpdateUserCampus`;
  url = `${services.files}/upload-reactions`;
  isFormData= true 

};

